export const API = {
  items: {
    path: '/items',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  item: {
    path: '/items/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  delete: {
    path: '/items/{{id}}',
    method: 'DELETE',
    get: null,
    auth: true,
    fallback: null,
  },

  create: {
    path: '/items',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => {
      return {
        data: {
          ...body,
          category: body?.category?.id,
        },
      };
    },
  },
  update: {
    path: '/items/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
    adapter: (body) => ({
      data: {
        ...body,
        category: body?.category?.id,
        id_item: body?.id_item?.id,
      },
    }),
  },
  selectINT: {
    path: '/items?filters[id_department][short_description][$eq]=INT&populate[id_department][fields][0]=short_description&populate[item_category][fields][0]=code&populate[item_category][fields][1]=description&populate[item_statistical_category][fields][0]=code&populate[item_statistical_category][fields][1]=description&populate[item_merchandise_group][fields][0]=code&populate[item_merchandise_group][fields][1]=description&pagination[page]=1&pagination[pageSize]=10000',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: `${item?.attributes?.mexal_code
          } - ${item?.attributes?.name_ITA ? item?.attributes?.name_ITA : ''} ${item?.attributes?.name_ENG ? `(${item?.attributes?.name_ENG})` : ''
          }`,
        id: item.id,
        mexal_code: item?.attributes?.mexal_code,
        description: item?.attributes?.description,
        category: item?.attributes?.category,
        item_category: item?.attributes?.item_category?.data
          ? {
            id: item?.attributes?.item_category?.data?.id,
            code: item?.attributes?.item_category?.data?.attributes?.code,
            description: item?.attributes?.item_category?.data?.attributes?.description,
          }
          : null,
        name_ITA: item?.attributes?.name_ITA,
        item_type_ITA: item?.attributes?.item_type_ITA,
        name_ENG: item?.attributes?.name_ENG,
        item_type_ENG: item?.attributes?.item_type_ENG,
        main_unit_measure: item?.attributes?.main_unit_measure,
        other_unit_of_measure: item?.attributes?.other_unit_of_measure,
        item_statistical_category: item?.attributes?.item_statistical_category?.data
          ? {
            id: item?.attributes?.item_statistical_category?.data?.id,
            code: item?.attributes?.item_statistical_category?.data?.attributes?.code,
            description: item?.attributes?.item_statistical_category?.data?.attributes?.description,
          }
          : null,
        item_merchandise_group: item?.attributes?.item_merchandise_group?.data
          ? {
            id: item?.attributes?.item_merchandise_group?.data?.id,
            code: item?.attributes?.item_merchandise_group?.data?.attributes?.code,
            description: item?.attributes?.item_merchandise_group?.data?.attributes?.description,
          }
          : null,
        nature: item?.attributes?.nature,
        vat_rate: item?.attributes?.vat_rate,
        price: item?.attributes?.price,
        existence: item?.attributes?.existence,
        location: item?.attributes?.location,
        sub_location: item?.attributes?.sub_location,
      })),
  },
  selectDEP: {
    path: '/items?filters[id_department][short_description][$eq]=DEP&populate[id_department][fields][0]=short_description&populate[item_category][fields][0]=code&populate[item_category][fields][1]=description&populate[item_statistical_category][fields][0]=code&populate[item_statistical_category][fields][1]=description&populate[item_merchandise_group][fields][0]=code&populate[item_merchandise_group][fields][1]=description&pagination[page]=1&pagination[pageSize]=10000',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: `${item?.attributes?.mexal_code
          } - ${item?.attributes?.name_ITA ? item?.attributes?.name_ITA : ''} ${item?.attributes?.name_ENG ? `(${item?.attributes?.name_ENG})` : ''
          }`,
        id: item.id,
        mexal_code: item?.attributes?.mexal_code,
        description: item?.attributes?.description,
        category: item?.attributes?.category,
        item_category: item?.attributes?.item_category?.data
          ? {
            id: item?.attributes?.item_category?.data?.id,
            code: item?.attributes?.item_category?.data?.attributes?.code,
            description: item?.attributes?.item_category?.data?.attributes?.description,
          }
          : null,
        name_ITA: item?.attributes?.name_ITA,
        item_type_ITA: item?.attributes?.item_type_ITA,
        name_ENG: item?.attributes?.name_ENG,
        item_type_ENG: item?.attributes?.item_type_ENG,
        main_unit_measure: item?.attributes?.main_unit_measure,
        other_unit_of_measure: item?.attributes?.other_unit_of_measure,
        item_statistical_category: item?.attributes?.item_statistical_category?.data
          ? {
            id: item?.attributes?.item_statistical_category?.data?.id,
            code: item?.attributes?.item_statistical_category?.data?.attributes?.code,
            description: item?.attributes?.item_statistical_category?.data?.attributes?.description,
          }
          : null,
        item_merchandise_group: item?.attributes?.item_merchandise_group?.data
          ? {
            id: item?.attributes?.item_merchandise_group?.data?.id,
            code: item?.attributes?.item_merchandise_group?.data?.attributes?.code,
            description: item?.attributes?.item_merchandise_group?.data?.attributes?.description,
          }
          : null,
        nature: item?.attributes?.nature,
        vat_rate: item?.attributes?.vat_rate,
        price: item?.attributes?.price,
        existence: item?.attributes?.existence,
        location: item?.attributes?.location,
        sub_location: item?.attributes?.sub_location,
      })),
  },
  selectPRV: {
    path: '/items?filters[id_department][short_description][$eq]=PRV&filters[id_department][short_description][$eq]=ENO&populate[id_department][fields][0]=short_description&populate[item_category][fields][0]=code&populate[item_category][fields][1]=description&populate[item_statistical_category][fields][0]=code&populate[item_statistical_category][fields][1]=description&populate[item_merchandise_group][fields][0]=code&populate[item_merchandise_group][fields][1]=description&pagination[page]=1&pagination[pageSize]=10000',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: `${item?.attributes?.mexal_code
          } - ${item?.attributes?.name_ITA ? item?.attributes?.name_ITA : ''} ${item?.attributes?.name_ENG ? `(${item?.attributes?.name_ENG})` : ''
          }`,
        id: item.id,
        mexal_code: item?.attributes?.mexal_code,
        description: item?.attributes?.description,
        category: item?.attributes?.category,
        item_category: item?.attributes?.item_category?.data
          ? {
            id: item?.attributes?.item_category?.data?.id,
            code: item?.attributes?.item_category?.data?.attributes?.code,
            description: item?.attributes?.item_category?.data?.attributes?.description,
          }
          : null,
        name_ITA: item?.attributes?.name_ITA,
        item_type_ITA: item?.attributes?.item_type_ITA,
        name_ENG: item?.attributes?.name_ENG,
        item_type_ENG: item?.attributes?.item_type_ENG,
        main_unit_measure: item?.attributes?.main_unit_measure,
        other_unit_of_measure: item?.attributes?.other_unit_of_measure,
        item_statistical_category: item?.attributes?.item_statistical_category?.data
          ? {
            id: item?.attributes?.item_statistical_category?.data?.id,
            code: item?.attributes?.item_statistical_category?.data?.attributes?.code,
            description: item?.attributes?.item_statistical_category?.data?.attributes?.description,
          }
          : null,
        item_merchandise_group: item?.attributes?.item_merchandise_group?.data
          ? {
            id: item?.attributes?.item_merchandise_group?.data?.id,
            code: item?.attributes?.item_merchandise_group?.data?.attributes?.code,
            description: item?.attributes?.item_merchandise_group?.data?.attributes?.description,
          }
          : null,
        nature: item?.attributes?.nature,
        vat_rate: item?.attributes?.vat_rate,
        price: item?.attributes?.price,
        existence: item?.attributes?.existence,
        location: item?.attributes?.location,
        sub_location: item?.attributes?.sub_location,
      })),
  },
  selectAG: {
    path: '/items?filters[id_department][short_description][$eq]=AG&populate[id_department][fields][0]=short_description&pagination[page]=1&pagination[pageSize]=100000',
    method: 'GET',
    get: null,
    auth: true,
    fallback: [],
    transform: (data) =>
      data?.data.map((item) => ({
        name: `${item?.attributes?.mexal_code
          } - ${item?.attributes?.name_ITA ? item?.attributes?.name_ITA : ''} ${item?.attributes?.name_ENG ? `(${item?.attributes?.name_ENG})` : ''
          }`,
        id: item.id,
      })),
  },
};
